import type { CSSProperties, ReactNode } from 'react'
import { SceneBackdrop } from './SceneBackdrop'

type GameStageProps = {
  sceneSrc: string
  palette: { bg: string; border: string; dot: string; tagBg: string; tagInk: string }
  children: ReactNode
}

export function GameStage({ sceneSrc, palette, children }: GameStageProps) {
  const style = {
    '--scene-bg': palette.bg,
    '--scene-border': palette.border,
    '--scene-dot': palette.dot,
    '--scene-tag-bg': palette.tagBg,
    '--scene-tag-ink': palette.tagInk
  } as CSSProperties

  return (
    <div className="game-stage" style={style}>
      <SceneBackdrop src={sceneSrc} background={palette.bg} />
      <div className="game-stage-content">{children}</div>
    </div>
  )
}
